import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=7c2a1256&"
import script from "./SortControl.vue?vue&type=script&lang=js&"
export * from "./SortControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports